export default function WhyChoose() {
  const benefits = [
    {
      icon: 'ri-award-line',
      title: 'Experiencia técnica especializada',
      description: 'Equipo de ingenieros con amplia experiencia en proyectos eléctricos e industriales'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Soluciones integrales de ingeniería',
      description: 'Desde el diseño hasta la ejecución, cubrimos todas las fases del proyecto'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Cumplimiento de normas técnicas',
      description: 'Todos nuestros proyectos cumplen con las normativas peruanas e internacionales'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Proyectos seguros y eficientes',
      description: 'Priorizamos la seguridad y la eficiencia energética en cada proyecto'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Atención directa de ingenieros',
      description: 'Comunicación directa con nuestros ingenieros especializados'
    },
    {
      icon: 'ri-time-line',
      title: 'Cumplimiento de plazos',
      description: 'Entregamos proyectos en tiempo y forma según lo acordado'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Por qué elegir <span className="text-blue-600">JDJ</span>
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Somos la mejor opción para tus proyectos de <strong>ingeniería eléctrica</strong> y <strong>arquitectura</strong> en <strong>Lima</strong> y el <strong>Perú</strong>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-blue-100 mb-5">
                <i className={`${benefit.icon} text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-12 text-center shadow-xl">
          <h3 className="text-3xl font-bold text-white mb-4">
            ¿Listo para iniciar tu proyecto?
          </h3>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Contáctanos hoy y recibe una cotización personalizada para tu proyecto de <strong>ingeniería</strong> o <strong>arquitectura</strong>
          </p>
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-blue-600 px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap"
          >
            Solicitar Cotización Ahora
          </button>
        </div>
      </div>
    </section>
  );
}